import { useFormStoreDatasContext } from "../../../store/useFormStoreDatas";
import { useGoogleTag } from "../../../hooks/useGoogleTag";
import { useEffect, useState } from "react";
import { Button } from "../../../cookies/icons/Button";

export const SelectedOffer = ({ lastStepFunction }: { lastStepFunction: (preferredProvider: string, consentement: boolean) => void }) => {
    useGoogleTag('SelectedOffer');
    const { formDatas } = useFormStoreDatasContext();

    const providers = [
        {
            title: "Orange",
            img: "/orange.png",
            month: "mois",
            year: "12 mois",
            details: [],
            amount: "29,99€",
            flowRate: "2 Gb/s",
            technology: "Fibre / Wi-Fi 7",
            phone: "Fixes & mobile illimitée",
            decoder: "Oui (200 chaînes)"
        },
        {
            title: "Free",
            img: "/free.png",
            month: "mois",
            year: "12 mois",
            details: [],
            amount: "19,99€",
            flowRate: "5 Gb/s",
            technology: "Fibre / Wi-Fi 7 + répéteur",
            phone: "",
            decoder: ""
        },
        {
            title: "Bouygues",
            img: "/bouygues.png",
            details: [],
            month: "mois",
            year: "12 mois",
            amount: "28,99€",
            flowRate: "1 Gb/s",
            technology: "Fibre / Wi-Fi 6",
            phone: "Fixes (+110 pays)",
            decoder: "Non (Appli mobile)"
        },
        {
            title: "SFR",
            img: "/sfr.png",
            details: [],
            month: "mois",
            year: "12 mois",
            amount: "29,99€",
            flowRate: "1 Gb/s",
            technology: "Fibre / Wi-Fi 6 + répéteur",
            phone: "Fixes (+100 pays)",
            decoder: "Oui (160 chaînes)"
        },
        {
            title: "Sosh",
            img: "/sosh.png",
            details: [],
            month: "mois",
            year: null,
            amount: "24,99€",
            flowRate: "2 Gb/s",
            technology: "Fibre / Wi-Fi 7 intégré",
            phone: "Fixes (+100 pays)",
            decoder: "Non (Appli mobile)"
        },
    ];
    const [showOffer, setShowOffer] = useState<any[]>([])
    const [position, setPosition] = useState<number | null>(null);
    const selectedProvider = (preferredProvider: string, index: number) => {
        setPosition(index);
        lastStepFunction(preferredProvider, false)
    }

    useEffect(() => {
        if (formDatas.provider) {
            switch (formDatas.provider.toLocaleLowerCase()) {
                case "bouygues":
                    setShowOffer(["orange", "free", "sosh", "sfr"]);
                    break;

                case "sfr":
                    setShowOffer(["orange", "free", "bouygues", "sosh"]);
                    break;

                case "free":
                    setShowOffer(["sosh", "sfr", "bouygues", "orange"]);
                    break;

                case "orange":
                    setShowOffer(["bouygues", "sfr", "free"]);
                    break;

                default:
                    setShowOffer(["free", "bouygues", "sfr", "sosh"]);
                    break;
            }
        }
    }, [formDatas]);
    return (
        <>
            <div className="">
                <div className="flex flex-col items-center justify-center gap-5 lg:-mt-2">
                    <h2 className="text-2xl text-center text-stone-700 px-2 lg:text-3xl font-bold">Choisissez une <strong className="text-primaryNewComparateurFibre">offre</strong></h2>
                    <div className="flex flex-col gap-4 w-[95%] mx-auto lg:w-full">
                        <div className={`grid grid-cols-1 gap-4 md:grid-cols-2 ${showOffer.length === 4 ? 'xl:grid-cols-4' : 'lg:grid-cols-3'}`}>
                            {providers.filter(provider => showOffer.includes(provider.title.toLocaleLowerCase())).map((provider, index) => (
                                <div key={index} onClick={() => selectedProvider(provider.title, index)} className={`${position === index ? 'border-orange-600' : ''} border cursor-pointer rounded-lg flex flex-col bg-white`}>

                                    <div className="bg-gray-50 border-b-[1px] p-2 rounded-t-lg w-full border-gray-200"><img src={provider.img} alt={provider.title} className="h-32 md:h- object-contain w-full" /></div>

                                    <div className="flex flex-col justify-between h-full bg-white rounded-b-lg p-3 gap-1.5">
                                        <div className="flex flex-col gap-1.5 lg:gap-0.5">
                                            <h3 className="font-bold text-xl">{provider.title}</h3>
                                            <p className="flex items-center justify-between lg:text-[15px]">
                                                <span><span className="text-2xl text-orange-600 font-bold">{provider.amount}</span> <span className="font-medium text-stone-600">/ {provider.month}</span></span>
                                                <span>{provider.year ?? "Sans engagement"}</span>
                                            </p>
                                            <div className="flex flex-col gap-1 lg:gap-1.5 lg:mt-1 md:text-sm">
                                                <p className="flex justify-between items-center">Débit : <span className="font-bold">{provider.flowRate}</span></p>
                                                <p className="flex justify-between items-center">Technologie : <span className="font-bold">{provider.technology}</span></p>
                                                {provider.phone && <p className="flex justify-between items-center">Téléphone : <span className="font-bold">{provider.phone}</span></p>}
                                                {provider.decoder && <p className="flex justify-between items-center">Décodeur TV : <span className="font-bold">{provider.decoder}</span></p>}
                                            </div>
                                        </div>
                                        <Button className="border-2 border-primaryNewComparateurFibre text-primaryNewComparateurFibre text-lg md:text-sm font-bold hover:bg-primaryNewComparateurFibre hover:text-white duration-300 ease-linear w-full mt-4">Choisir cette offre</Button>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
